import axios from "axios";
import LocalStorageService from "./local-storage.service";
import { toast } from "react-toastify";
import { getAccountsUrl } from "../../utils/accountsUrl";
import { BRAND } from "../brand/brand-config";
const localStorageService = LocalStorageService.getService();
import * as Sentry from "@sentry/browser";

// Add a request interceptor
axios.interceptors.request.use(
  (config) => {
    config.headers = config.headers || {};
    if (localStorageService.getAccessToken()) {
      const token = localStorageService.getAccessToken();
      if (token) {
        config.headers["ssoToken"] = token;
      }
    }
    if (localStorageService.getSessionID()) {
      const session_id = localStorageService.getSessionID();
      config.headers["sessionId"] = session_id;
    }
    config.headers["source"] = BRAND.key;
    config.headers["Content-Type"] = "application/json";
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

//Add a response interceptor

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  function (error) {
    const originalRequest = error.config;

    // Check for CORS error
    if (error?.message.includes("CORS")) {
      Sentry.captureException(new Error("CORS error: " + error.message));
    }

    // Check for 401 Unauthorized error
    if (!!error && !!error.response && error.response.status === 401) {
      const emailParams = window.location.search;
      if (!emailParams.includes("Email")) {
        toast.error(error?.response?.data?.message ?? "Your session has expired. Please login again");
        localStorageService.clearCompleteStorage();
      }
      if (!!originalRequest && !!originalRequest.data) {
        const salesforceRedirectionData = JSON.parse(originalRequest.data);
        if (salesforceRedirectionData && salesforceRedirectionData !== "" && salesforceRedirectionData.sfint) {
          setTimeout(() => {
            window.location = getAccountsUrl() + "?&authentication=false&company_id=" + salesforceRedirectionData.company_id + "&slug=" + salesforceRedirectionData.company_slug + "&salesforce=" + salesforceRedirectionData.sfint;
          }, 4000);
        } else {
          setTimeout(() => {
            window.location = !!emailParams && emailParams !== "" ? getAccountsUrl() + "?&authentication=false&" + emailParams.replace("?", "") : getAccountsUrl() + "?&authentication=false";
          }, 4000);
        }
      } else {
        setTimeout(() => {
          window.location = !!emailParams && emailParams !== "" ? getAccountsUrl() + "?&authentication=false&" + emailParams.replace("?", "") : getAccountsUrl() + "?&authentication=false";
        }, 4000);
      }
    }
    return Promise.reject(error);
  }
);
